const NO_POLLING_STATUSES = new Set(['COMPLETED', 'FINISHED']);

export const getIsDocumentVisible = () =>
  typeof document === 'undefined' ? true : document.visibilityState !== 'hidden';

/** FINISHED se trata como partido terminado (mismo criterio que COMPLETED para polling). */
export const normalizeMatchStatusForPolling = status =>
  status === 'FINISHED' ? 'COMPLETED' : status;

/**
 * @param {object|null|undefined} livefeedConfig
 * @param {string|null|undefined} matchStatus
 * @returns {number|null}
 */
export const resolveMatchDetailPollingIntervalMs = (livefeedConfig, matchStatus) => {
  if (!livefeedConfig?.enabled || !livefeedConfig?.polling?.intervalsByMatchStatus) {
    return null;
  }

  const normalizedStatus = normalizeMatchStatusForPolling(matchStatus);
  if (NO_POLLING_STATUSES.has(normalizedStatus)) return null;

  const intervalsByStatus =
    livefeedConfig?.polling?.intervalsByMatchStatus ?? {};

  const intervalMs =
    intervalsByStatus[matchStatus] ??
    intervalsByStatus[normalizedStatus] ??
    intervalsByStatus.UNKNOWN;

  return typeof intervalMs === 'number' && intervalMs > 0 ? intervalMs : null;
};

export function patchMatchStatusFromFeed(patch, feedStatus, currentMatchCard) {
  const baseCard =
    patch.matchCard?.[0] ??
    (Array.isArray(currentMatchCard) ? currentMatchCard[0] : null);

  if (!feedStatus || !baseCard) {
    return;
  }

  const nextStatus = String(feedStatus).trim();
  if (!nextStatus || baseCard.status === nextStatus) {
    return;
  }

  patch.matchCard = [{ ...baseCard, status: nextStatus }];
}

export function patchMatchProgressFromFeed(patch, feedMatchProgress, currentMatchCard) {
  if (feedMatchProgress == null) {
    return;
  }

  const baseCard =
    patch.matchCard?.[0] ??
    (Array.isArray(currentMatchCard) ? currentMatchCard[0] : null);

  if (!baseCard) {
    return;
  }

  const summary = baseCard.summary ?? {};
  const currentProgress = summary.matchProgress;

  if (
    currentProgress?.period === feedMatchProgress.period &&
    currentProgress?.minute === feedMatchProgress.minute &&
    currentProgress?.second === feedMatchProgress.second
  ) {
    return;
  }

  patch.matchCard = [
    {
      ...baseCard,
      summary: {
        ...summary,
        matchProgress: feedMatchProgress,
      },
    },
  ];
}

export function isMatchPollingAllowed(matchId, matchStatus, isPageVisible) {
  if (!matchId || !isPageVisible) return false;
  const normalizedStatus = normalizeMatchStatusForPolling(matchStatus);
  return !NO_POLLING_STATUSES.has(normalizedStatus);
}
